export default "__VITE_ASSET__VZsBvyOA__"